import React from "react";
import { Space, Input, Card, Table, Button } from "antd";
import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import { useHistory, Link } from "react-router-dom";
import { ETransferEmployeeStatus } from "../../types/transferEmployee.type";
import NotSet from "../../components/NotSet";
import TransferEmployeeStatus from "../../components/TransferEmployeeStatus";
import HeaderSection from "../../components/HeaderSection";
import Filter from "../../components/Filter";
import CustomPagination from "../../components/CustomPagination";
import { ListTransferMemberTeamQuery, TransferMemberTeamProperties } from "../../types/transferMemberTeam.type";
import useFetchList from "../../hooks/useFetchList";
import { formatYearToTime } from "../../helpers/format";
import useAuth from "../../hooks/useAuth";

const TransferMember: React.FC = () => {
	const history = useHistory();
	const { isAdminHQAndAdminOffices } = useAuth();

	const handleAdd = () => history.push("/transfer-team-member/create");
	const { isLoading, data, pagination, search, setSearch, changePage } = useFetchList<
		TransferMemberTeamProperties,
		ListTransferMemberTeamQuery
	>({
		endpoint: "transfer-member-teams",
		initialQuery: {
			sort: "createdAt:DESC",
			includeData: "originGroupMember,toGroupMember,originGroup,user,toGroup",
		},
	});

	const COLUMNS = [
		{
			title: "USER ID",
			dataIndex: ["originGroupMember", "employee", "employeeCode"],
			key: "employeeTransferCode",
			width: "150px",
			render: (employeeCode: string, record: TransferMemberTeamProperties) => {
				return (
					<Link to={"/transfer-team-member/" + record.transferMemberId}>
						{employeeCode ? employeeCode.toUpperCase() : <NotSet />}
					</Link>
				);
			},
		},
		{
			title: "NAME",
			dataIndex: ["user", "nickName"],
			key: "agentName",
			render: (nickName: string) => <>{nickName ? nickName?.toUpperCase() : <NotSet />}</>,
		},
		{
			title: "FROM TEAM",
			dataIndex: ["originGroup", "groupName"],
			key: "originGroup",
		},
		{
			title: "TO TEAM",
			dataIndex: ["toGroup", "groupName"],
			key: "toGroup",
		},
		{
			title: "TRANSFER AT",
			dataIndex: "createdAt",
			render: (createdAt: Date | undefined) => {
				return createdAt ? formatYearToTime(createdAt) : <NotSet />;
			},
		},
		{
			title: "STATUS",
			dataIndex: "status",
			key: "status",
			render: (status: ETransferEmployeeStatus) => {
				return <TransferEmployeeStatus value={status} />;
			},
		},
	];

	return (
		<React.Fragment>
			<Space
				direction="vertical"
				size="large"
			>
				<HeaderSection
					title="Transfer Team Member"
					rightComponent={
						isAdminHQAndAdminOffices && (
							<Button
								icon={<PlusOutlined />}
								type="primary"
								onClick={handleAdd}
							>
								Create Transfer Team Member
							</Button>
						)
					}
				>
					<Filter>
						<Filter.Medium>
							<Input
								className="outer-shadow"
								placeholder="Search by Name..."
								suffix={<SearchOutlined />}
								allowClear
								onChange={(e) => setSearch(e.target.value)}
								value={search}
							/>
						</Filter.Medium>
					</Filter>
				</HeaderSection>
				<Card
					bordered={false}
					size="small"
				>
					<Table
						loading={isLoading}
						columns={COLUMNS}
						dataSource={data}
						rowKey="employeeTransferId"
						pagination={false}
						scroll={{ x: "100%" }}
					/>
					<CustomPagination
						current={pagination.page}
						total={pagination.totalData}
						defaultPageSize={pagination.perPage}
						pageSize={pagination.perPage}
						onChange={changePage}
					/>
				</Card>
			</Space>
		</React.Fragment>
	);
};
export default TransferMember;
